/**
 * BOOKING Availability Type Configuration
 *
 * Default zone configurations for BOOKING availability type.
 * Used when timeslots are instantly bookable (no approval required).
 * Journeys can override specific properties for journey-specific UX.
 */

import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { AvailabilityTypePageConfig } from '../models/checkout-journey.types';
import { CheckoutStore } from '../checkout.store';
import { JourneyStore } from '../journey.store';
import { AssociationsStore } from '@app/features/associations/store/associations.store';
import { BasketStore } from '@app/features/associations/components/basket/basket.store';
import { navigateToLastUserSearch } from './checkout-journeys.config';

export const BOOKING_AVAILABILITY_TYPE_CONFIG: AvailabilityTypePageConfig[] = [
  {
    pageRoute: 'addons',
    zoneConfig: {
      actions: [
        {
          id: 'next',
          buttonLabel: 'Videre til Foreningsinfo',
          action: 'next',
          disabled: () => false, // Can be overridden by journey
        },
      ],
    },
  },
  {
    pageRoute: 'association-info',
    zoneConfig: {
      actions: [
        {
          id: 'next',
          buttonLabel: 'Videre til oversigt',
          action: 'next',
        },
      ],
    },
  },
  {
    pageRoute: 'summary',
    zoneConfig: {
      actions: [
        {
          id: 'submit',
          buttonLabel: 'Gennemfør booking',
          action: 'submit',
          callback: async () => {
            const checkoutStore = inject(CheckoutStore);
            const basketStore = inject(BasketStore);
            const router = inject(Router);

            try {
              await checkoutStore.completeBooking(checkoutStore.bookingId());

              if (!checkoutStore.error()) {
                basketStore.clearBasket();
                await router.navigate(['/checkout/complete'], {
                  queryParams: { uid: checkoutStore.booking()?.uid },
                });
              } else {
                await router.navigate(['/checkout/error']);
              }
            } catch {
              await router.navigate(['/checkout/error']);
            }
          },
        },
      ],
    },
  },
  {
    pageRoute: 'complete',
    zoneConfig: {
      summaryContent: {
        title: 'Din booking er bekræftet',
        message: '- Vi glæder os til at se dig på banen.',
        illustrationPath: './assets/illustrations/checkout-goalline.svg',
      },
      actions: [
        {
          id: 'primary-action',
          buttonLabel: 'Se dine bookinger',
          buttonType: 'filled',
          action: 'custom',
          callback: async () => {
            const associationsStore = inject(AssociationsStore);
            const router = inject(Router);
            const entityId = associationsStore.selectedEntityId();
            await router.navigate([`/associations/${entityId}/bookings`], {
              queryParams: { tab: 'future' },
            });
          },
        },
        {
          id: 'secondary-action',
          buttonLabel: 'Søg efter nye tider',
          buttonType: 'outlined',
          action: 'custom',
          callback: async () => {
            const journeyStore = inject(JourneyStore);
            const router = inject(Router);
            await navigateToLastUserSearch(journeyStore, router);
          },
        },
      ],
    },
  },
];
